import { render, staticRenderFns } from "./LiveChannel.vue?vue&type=template&id=1368fbfb&"
import script from "./LiveChannel.vue?vue&type=script&lang=js&"
export * from "./LiveChannel.vue?vue&type=script&lang=js&"
import style0 from "./LiveChannel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports